/* ============================================================================
   NOLESSIA · nls.js — TODO el JavaScript del theme. Vanilla, sin dependencias.
   Cuatro componentes y nada mas. Si algo se puede hacer con HTML o CSS, no
   esta aqui (el menu movil es un <details>, el acordeon tambien).

   Por que tan poco: la tienda de hoy carga 58 scripts en la home (medido
   13-sep-2026 contando <script src> en el HTML de nolessia.com). "Cuanto mas
   sencillo, mejor" -> curso de Javi, leccion 10 [03:39].

   Todo degrada: sin JS la ficha sigue vendiendo (el formulario es un POST a
   /cart/add de toda la vida) y la galeria sigue mostrando la foto principal.
   ========================================================================== */
(function () {
  "use strict";

  var dinero = function (c) {
    // formato por defecto; el theme lo pisa desde el data-atributo del <body>
    var f = (document.body && document.body.dataset.formatoDinero) || "{{amount_with_comma_separator}} EUR";
    var n = (c / 100).toFixed(2);
    if (f.indexOf("comma_separator") > -1) {
      n = n.replace(".", ",").replace(/\B(?=(\d{3})+(?!\d),)/g, ".");
    }
    return f.replace(/\{\{\s*\w+\s*\}\}/, n);
  };

  /* ---- 1 · GALERIA -------------------------------------------------------
     Cambia la foto grande al pulsar una miniatura. Sin libreria de carrusel. */
  customElements.define("nls-galeria", class extends HTMLElement {
    connectedCallback() {
      this.principal = this.querySelector("[data-principal]");
      this.addEventListener("click", function (e) {
        var b = e.target.closest("[data-tira]");
        if (!b || !this.principal) return;
        var src = b.dataset.tira, alt = b.dataset.alt || "";
        this.principal.src = src;
        this.principal.srcset = b.dataset.srcset || "";
        this.principal.alt = alt;
        this.querySelectorAll("[data-tira]").forEach(function (x) {
          x.setAttribute("aria-current", x === b ? "true" : "false");
        });
      }.bind(this));
    }
  });

  /* ---- 2 · SELECTOR DE VARIANTE ------------------------------------------
     Lee el JSON de variantes que imprime Liquid y actualiza precio, boton,
     disponibilidad y la URL. Nada de peticiones al servidor. */
  customElements.define("nls-variantes", class extends HTMLElement {
    connectedCallback() {
      var guion = this.querySelector('script[type="application/json"]');
      if (!guion) return;
      try { this.variantes = JSON.parse(guion.textContent); } catch (e) { return; }
      this.addEventListener("change", this.recalcular.bind(this));
    }
    recalcular() {
      var elegidas = Array.from(this.querySelectorAll("input:checked")).map(function (i) { return i.value; });
      var v = this.variantes.find(function (x) {
        return x.opciones.every(function (o, i) { return o === elegidas[i]; });
      });
      var idCampo = this.querySelector('input[name="id"]');
      var boton   = document.getElementById(this.dataset.boton);
      var precio  = document.getElementById(this.dataset.precio);

      if (!v) {
        if (boton) { boton.disabled = true; boton.textContent = this.dataset.textoNoExiste || "No disponible"; }
        return;
      }
      if (idCampo) idCampo.value = v.id;
      if (precio) {
        var html = '<span class="precio__ahora">' + dinero(v.precio) + "</span>";
        if (v.comparado && v.comparado > v.precio) {
          html += '<s class="precio__antes">' + dinero(v.comparado) + "</s>";
        }
        precio.innerHTML = html;
      }
      if (boton) {
        boton.disabled = !v.disponible;
        boton.textContent = v.disponible
          ? (this.dataset.textoComprar || "Anadir al carrito")
          : (this.dataset.textoAgotado || "Agotado");
      }
      if (v.id && history.replaceState) {
        var u = new URL(location.href);
        u.searchParams.set("variant", v.id);
        history.replaceState({}, "", u);
      }
    }
  });

  /* ---- 3 · CANTIDAD ------------------------------------------------------ */
  customElements.define("nls-cantidad", class extends HTMLElement {
    connectedCallback() {
      var campo = this.querySelector("input");
      this.addEventListener("click", function (e) {
        var b = e.target.closest("button[data-paso]");
        if (!b || !campo) return;
        e.preventDefault();
        var n = parseInt(campo.value, 10) || 1;
        n += parseInt(b.dataset.paso, 10);
        var min = parseInt(campo.min, 10) || 1;
        campo.value = Math.max(min, n);
        campo.dispatchEvent(new Event("change", { bubbles: true }));
      });
    }
  });

  /* ---- 4 · ANADIR AL CARRITO SIN RECARGAR --------------------------------
     Si falla cualquier cosa (red, JS viejo), se deja que el formulario haga
     su POST normal: la venta no depende de este script. */
  customElements.define("nls-form-producto", class extends HTMLElement {
    connectedCallback() {
      var form = this.querySelector("form");
      if (!form) return;
      form.addEventListener("submit", function (e) {
        if (!window.fetch) return;                 // navegador viejo: POST normal
        e.preventDefault();
        var boton = form.querySelector('[type="submit"]');
        var textoPrevio = boton ? boton.textContent : "";
        if (boton) { boton.disabled = true; boton.textContent = this.dataset.textoAnadiendo || "Añadiendo…"; }

        fetch("/cart/add.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify(serializar(form))
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j.description || res.j.message || "error");
            return fetch("/cart.js").then(function (r) { return r.json(); });
          })
          .then(function (carrito) {
            document.querySelectorAll("[data-contador-carrito]").forEach(function (c) {
              c.textContent = carrito.item_count;
              c.hidden = carrito.item_count === 0;
            });
            if (boton) boton.textContent = this.dataset.textoAnadido || "Añadido";
            try { if (window.nlsCajon) window.nlsCajon(carrito); } catch (err) { /* sin cajón: el producto ya está añadido */ }
            setTimeout(function () {
              if (boton) { boton.disabled = false; boton.textContent = textoPrevio; }
            }, 1600);
          }.bind(this))
          .catch(function () {
            // no se traga el fallo en silencio: se manda al carrito de verdad
            form.submit();
          });
      }.bind(this));
    }
  });

  /* ---- 5 · VÍDEO EN TARJETA (19-sep) ----------------------------------------
     Con ratón: se reproduce al pasar por encima. Sin ratón (móvil): cuando la
     tarjeta está al menos al 60 % en pantalla, y se para al salir, para no
     tener 8 vídeos sonando a la vez. Mudo siempre. Si no hay vídeo en la
     tarjeta, este bloque no hace nada. */
  var videos = document.querySelectorAll("[data-video-tarjeta]");
  if (videos.length) {
    var reproducir = function (v) {
      var p = v.play();
      if (p && p.then) p.then(function () { v.classList.add("esta-sonando"); }).catch(function () {});
      else v.classList.add("esta-sonando");
    };
    var parar = function (v) { v.pause(); v.classList.remove("esta-sonando"); };
    var conRaton = window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    if (conRaton) {
      videos.forEach(function (v) {
        var t = v.closest(".tarjeta") || v;
        t.addEventListener("mouseenter", function () { reproducir(v); });
        t.addEventListener("mouseleave", function () { parar(v); });
      });
    } else if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entradas) {
        entradas.forEach(function (e) { e.isIntersecting ? reproducir(e.target) : parar(e.target); });
      }, { threshold: 0.6 });
      videos.forEach(function (v) { io.observe(v); });
    }
  }

  function serializar(form) {
    var d = new FormData(form), o = {};
    d.forEach(function (v, k) {
      if (k.indexOf("properties[") === 0) {
        o.properties = o.properties || {};
        o.properties[k.slice(11, -1)] = v;
      } else { o[k] = v; }
    });
    o.quantity = parseInt(o.quantity, 10) || 1;
    return o;
  }
})();


/* ============================================================================
   26-sep · CARRITO LATERAL tras añadir.
   Solo datos del propio carrito (/cart.js): la última línea, el nº de artículos
   y el total. Nada de urgencias ni contadores. Sin JS o si falla, no aparece y
   el contador de la cabecera sigue funcionando como antes.
   ========================================================================== */
(function () {
  "use strict";
  function dinero(c) {
    var f = document.body.getAttribute("data-formato-dinero") || "€{{amount_with_comma_separator}}";
    var v = (c / 100).toFixed(2).replace(".", ",");
    return f.replace(/\{\{\s*amount[a-z_]*\s*\}\}/, v);
  }
  function esc(t) { var d = document.createElement("div"); d.textContent = t || ""; return d.innerHTML; }
  function cerrar() { var c = document.getElementById("nls-cajon"); if (c) { c.classList.remove("abierto"); setTimeout(function(){ if (c.parentNode) c.parentNode.removeChild(c); }, 300); } }
  window.nlsCajon = function (carrito) {
    if (!carrito || !carrito.items || !carrito.items.length) return;
    cerrar();
    var it = carrito.items[0];
    var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2") : "";
    var var_ = (it.variant_title && it.variant_title.indexOf("Default") < 0) ? '<span class="nls-cajon__var">' + esc(it.variant_title) + "</span>" : "";
    var el = document.createElement("div");
    el.id = "nls-cajon"; el.className = "nls-cajon"; el.setAttribute("role", "dialog"); el.setAttribute("aria-label", "Añadido al carrito");
    el.innerHTML =
      '<div class="nls-cajon__fondo" data-cerrar></div>' +
      '<div class="nls-cajon__panel">' +
        '<div class="nls-cajon__cab"><strong>Añadido al carrito</strong><button type="button" class="nls-cajon__x" data-cerrar aria-label="Cerrar">×</button></div>' +
        '<div class="nls-cajon__linea">' + (img ? '<img src="' + img + '" alt="" width="72" height="72">' : "") +
          '<div><span class="nls-cajon__nom">' + esc(it.product_title) + "</span>" + var_ +
          '<span class="nls-cajon__pre">' + it.quantity + " × " + dinero(it.final_price) + "</span></div></div>" +
        '<div class="nls-cajon__tot"><span>Total (' + carrito.item_count + (carrito.item_count === 1 ? " artículo" : " artículos") + ")</span><strong>" + dinero(carrito.total_price) + "</strong></div>" +
        '<p class="nls-cajon__nota">El coste del envío se ve antes de pagar.</p>' +
        '<a class="boton boton--ancho" href="/checkout">Finalizar compra</a>' +
        '<a class="boton boton--secundario boton--ancho" href="/cart">Ver carrito</a>' +
        '<button type="button" class="nls-cajon__seguir" data-cerrar>Seguir mirando</button>' +
      "</div>";
    document.body.appendChild(el);
    el.addEventListener("click", function (e) { if (e.target.closest("[data-cerrar]")) cerrar(); });
    document.addEventListener("keydown", function k(e) { if (e.key === "Escape") { cerrar(); document.removeEventListener("keydown", k); } });
    requestAnimationFrame(function () { el.classList.add("abierto"); var x = el.querySelector(".nls-cajon__x"); if (x) x.focus(); });
  };
})();
